!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactCrop = t(require("react")) : e.ReactCrop = t(e.React);
}(this, function (e) {
  return (() => {
    var t = {
        703: (e, t, r) => {
          "use strict";

          var o = r(414);
          function n() {}
          function i() {}
          i.resetWarningCache = n, e.exports = function () {
            function e(e, t, r, n, i, a) {
              if (a !== o) {
                var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw s.name = "Invariant Violation", s;
              }
            }
            function t() {
              return e;
            }
            e.isRequired = e;
            var r = {
              array: e,
              bool: e,
              func: e,
              number: e,
              object: e,
              string: e,
              symbol: e,
              any: e,
              arrayOf: t,
              element: e,
              elementType: e,
              instanceOf: t,
              node: e,
              objectOf: t,
              oneOf: t,
              oneOfType: t,
              shape: t,
              exact: t,
              checkPropTypes: i,
              resetWarningCache: n
            };
            return r.PropTypes = r, r;
          };
        },
        697: (e, t, r) => {
          e.exports = r(703)();
        },
        414: e => {
          "use strict";

          e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        427: t => {
          "use strict";

          t.exports = e;
        }
      },
      r = {};
    function o(e) {
      var n = r[e];
      if (void 0 !== n) return n.exports;
      var i = r[e] = {
        exports: {}
      };
      return t[e](i, i.exports, o), i.exports;
    }
    o.n = e => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return o.d(t, {
        a: t
      }), t;
    }, o.d = (e, t) => {
      for (var r in t) o.o(t, r) && !o.o(e, r) && Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      });
    }, o.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), o.r = e => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var n = {};
    return (() => {
      "use strict";

      o.r(n), o.d(n, {
        Component: () => S,
        containCrop: () => O,
        default: () => S,
        makeAspectCrop: () => C
      });
      var e = o(427),
        t = o.n(e),
        r = o(697),
        i = o.n(r);
      function a(e) {
        var t,
          r,
          o = "";
        if ("string" == typeof e || "number" == typeof e) o += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (r = a(e[t])) && (o && (o += " "), o += r);else for (t in e) e[t] && (o && (o += " "), o += t);
        return o;
      }
      function s(e) {
        return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function c(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function d(e, t) {
        for (var r = 0; r < t.length; r++) {
          var o = t[r];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }
      function p(e, t) {
        return (p = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function h(e, t) {
        return !t || "object" !== s(t) && "function" != typeof t ? u(e) : t;
      }
      function u(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      function l(e) {
        return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      function f(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t && (o = o.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, o);
        }
        return r;
      }
      function m(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? f(Object(r), !0).forEach(function (t) {
            v(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }
      function v(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }
      function g(e, t, r) {
        return Math.min(Math.max(e, t), r);
      }
      function y(e) {
        return e && !isNaN(e.width) && !isNaN(e.height);
      }
      function w(e) {
        return "n" === e ? "s" : "ne" === e ? "sw" : "e" === e ? "w" : "se" === e ? "nw" : "s" === e ? "n" : "sw" === e ? "ne" : "w" === e ? "e" : "nw" === e ? "se" : e;
      }
      function C(e, t, r) {
        if (isNaN(e.aspect)) return console.warn("`crop.aspect` should be a number in order to make an aspect crop", e), e;
        var o = m({
          unit: "px",
          x: 0,
          y: 0
        }, e);
        return e.width && (o.height = o.width / e.aspect), e.height && (o.width = o.height * e.aspect), o.y + o.height > r && (o.height = r - o.y, o.width = o.height * e.aspect), o.x + o.width > t && (o.width = t - o.x, o.height = o.width / e.aspect), o;
      }
      function b(e, t, r) {
        return "%" === e.unit ? e : {
          unit: "%",
          aspect: e.aspect,
          x: e.x / t * 100,
          y: e.y / r * 100,
          width: e.width / t * 100,
          height: e.height / r * 100
        };
      }
      function x(e, t, r) {
        return e.unit ? "px" === e.unit ? e : {
          unit: "px",
          aspect: e.aspect,
          x: e.x * t / 100,
          y: e.y * r / 100,
          width: e.width * t / 100,
          height: e.height * r / 100
        } : m(m({}, e), {}, {
          unit: "px"
        });
      }
      function O(e, t, r, o) {
        var n = x(t, r, o),
          i = x(e, r, o),
          a = m({}, n);
        if (!n.aspect) return n.x < 0 ? (a.x = 0, a.width += n.x) : n.x + n.width > r && (a.width = r - n.x), n.y + n.height > o && (a.height = o - n.y), a;
        var s = !1;
        n.x < 0 ? (a.x = 0, a.width += n.x, a.height = a.width / n.aspect, s = !0) : n.x + n.width > r && (a.width = r - n.x, a.height = a.width / n.aspect, s = !0), s && i.y > a.y && (a.y = n.y + (n.height - a.height));
        var c = !1;
        return a.y + a.height > o && (a.height = o - n.y, a.width = a.height * n.aspect, c = !0), c && i.x > a.x && (a.x = n.x + (n.width - a.width)), a;
      }
      var D = {
          capture: !0,
          passive: !1
        },
        S = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && p(e, t);
          }(f, e);
          var r,
            o,
            n,
            i,
            s = (n = f, i = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (e) {
                return !1;
              }
            }(), function () {
              var e,
                t = l(n);
              if (i) {
                var r = l(this).constructor;
                e = Reflect.construct(t, arguments, r);
              } else e = t.apply(this, arguments);
              return h(this, e);
            });
          function f() {
            var e;
            c(this, f);
            for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++) r[o] = arguments[o];
            return v(u(e = s.call.apply(s, [this].concat(r))), "window", "undefined" != typeof window ? window : {}), v(u(e), "document", "undefined" != typeof document ? document : {}), v(u(e), "state", {}), v(u(e), "keysDown", new Set()), v(u(e), "onCropPointerDown", function (t) {
              var r = e.props,
                o = r.crop,
                n = r.disabled,
                i = e.mediaDimensions,
                a = x(o, i.width, i.height);
              if (!n) {
                t.cancelable && t.preventDefault(), e.bindDocMove(), e.componentRef.focus({
                  preventScroll: !0
                });
                var s = t.target.dataset.ord,
                  c = "nw" === s || "w" === s || "sw" === s,
                  d = "nw" === s || "n" === s || "ne" === s;
                e.evData = {
                  clientStartX: t.clientX,
                  clientStartY: t.clientY,
                  cropStartWidth: a.width,
                  cropStartHeight: a.height,
                  cropStartX: c ? a.x + a.width : a.x,
                  cropStartY: d ? a.y + a.height : a.y,
                  xInversed: c,
                  yInversed: d,
                  xCrossOver: c,
                  yCrossOver: d,
                  startXCrossOver: c,
                  startYCrossOver: d,
                  isResize: t.target.dataset.ord,
                  ord: s
                }, e.mouseDownOnCrop = !0, e.setState({
                  cropIsActive: !0
                });
              }
            }), v(u(e), "onComponentPointerDown", function (t) {
              var r = e.props,
                o = r.crop,
                n = r.disabled,
                i = r.locked,
                a = r.keepSelection,
                s = r.onChange,
                c = e.mediaWrapperRef.firstChild;
              if (t.target === c && c.contains(t.target) && !(n || i || a && y(o))) {
                t.cancelable && t.preventDefault(), e.bindDocMove(), e.componentRef.focus({
                  preventScroll: !0
                });
                var d = e.mediaWrapperRef.getBoundingClientRect(),
                  p = t.clientX - d.left,
                  h = t.clientY - d.top,
                  u = {
                    unit: "px",
                    aspect: o ? o.aspect : void 0,
                    x: p,
                    y: h,
                    width: 0,
                    height: 0
                  };
                e.evData = {
                  clientStartX: t.clientX,
                  clientStartY: t.clientY,
                  cropStartWidth: u.width,
                  cropStartHeight: u.height,
                  cropStartX: u.x,
                  cropStartY: u.y,
                  xInversed: !1,
                  yInversed: !1,
                  xCrossOver: !1,
                  yCrossOver: !1,
                  startXCrossOver: !1,
                  startYCrossOver: !1,
                  isResize: !0,
                  ord: "nw"
                }, e.mouseDownOnCrop = !0;
                var l = e.mediaDimensions,
                  f = l.width,
                  m = l.height;
                s(x(u, f, m), b(u, f, m)), e.setState({
                  cropIsActive: !0,
                  newCropIsBeingDrawn: !0
                });
              }
            }), v(u(e), "onDocPointerMove", function (t) {
              var r = e.props,
                o = r.crop,
                n = r.disabled,
                i = r.onChange,
                a = r.onDragStart;
              if (!n && e.mouseDownOnCrop) {
                t.cancelable && t.preventDefault(), e.dragStarted || (e.dragStarted = !0, a(t));
                var s,
                  c = u(e).evData;
                if (c.xDiff = t.clientX - c.clientStartX, c.yDiff = t.clientY - c.clientStartY, (s = c.isResize ? e.resizeCrop() : e.dragCrop()) !== o) {
                  var d = e.mediaDimensions,
                    p = d.width,
                    h = d.height;
                  i(x(s, p, h), b(s, p, h));
                }
              }
            }), v(u(e), "onComponentKeyDown", function (t) {
              var r = e.props,
                o = r.crop,
                n = r.disabled,
                i = r.onChange,
                a = r.onComplete;
              if (!n) {
                e.keysDown.add(t.key);
                var s = !1;
                if (y(o)) {
                  var c = e.makeNewCrop(),
                    d = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? f.nudgeStepLarge : t.shiftKey ? f.nudgeStepMedium : f.nudgeStep;
                  if (e.keysDown.has("ArrowLeft") && (c.x -= d, s = !0), e.keysDown.has("ArrowRight") && (c.x += d, s = !0), e.keysDown.has("ArrowUp") && (c.y -= d, s = !0), e.keysDown.has("ArrowDown") && (c.y += d, s = !0), s) {
                    t.cancelable && t.preventDefault();
                    var p = e.mediaDimensions,
                      h = p.width,
                      u = p.height;
                    c.x = g(c.x, 0, h - c.width), c.y = g(c.y, 0, u - c.height);
                    var l = x(c, h, u),
                      m = b(c, h, u);
                    i(l, m), a(l, m);
                  }
                }
              }
            }), v(u(e), "onComponentKeyUp", function (t) {
              e.keysDown.delete(t.key);
            }), v(u(e), "onDocPointerDone", function (t) {
              var r = e.props,
                o = r.crop,
                n = r.disabled,
                i = r.onComplete,
                a = r.onDragEnd;
              if (e.unbindDocMove(), !n && e.mouseDownOnCrop) {
                e.mouseDownOnCrop = !1, e.dragStarted = !1;
                var s = e.mediaDimensions,
                  c = s.width,
                  d = s.height;
                a(t), i(x(o, c, d), b(o, c, d)), e.setState({
                  cropIsActive: !1,
                  newCropIsBeingDrawn: !1
                });
              }
            }), v(u(e), "onMediaLoaded", function () {
              var t = e.props,
                r = t.onComplete,
                o = t.onChange,
                n = e.createNewCrop(),
                i = n.pixelCrop,
                a = n.percentCrop;
              o(i, a), r(i, a);
            }), v(u(e), "onImageLoad", function (t) {
              var r = t.target,
                o = e.props,
                n = o.onComplete,
                i = o.onChange;
              if (!1 !== (0, o.onImageLoaded)(r)) {
                var a = e.createNewCrop(),
                  s = a.pixelCrop,
                  c = a.percentCrop;
                i(s, c), n(s, c);
              }
            }), v(u(e), "bindComponentRef", function (t) {
              e.componentRef = t;
            }), v(u(e), "bindMediaWrapperRef", function (t) {
              e.mediaWrapperRef = t;
            }), v(u(e), "bindImageRef", function (t) {
              e.imageRef = t;
            }), v(u(e), "bindCropSelectionRef", function (t) {
              e.cropSelectRef = t;
            }), e;
          }
          return r = f, (o = [{
            key: "componentDidMount",
            value: function () {
              this.componentRef.addEventListener && this.componentRef.addEventListener("medialoaded", this.onMediaLoaded);
            }
          }, {
            key: "componentWillUnmount",
            value: function () {
              this.componentRef.removeEventListener && this.componentRef.removeEventListener("medialoaded", this.onMediaLoaded);
            }
          }, {
            key: "componentDidUpdate",
            value: function (e) {
              var t = this.props.crop;
              if (this.imageRef && e.crop !== t && t.aspect && (t.width && !t.height || !t.width && t.height)) {
                var r = this.imageRef,
                  o = r.width,
                  n = r.height,
                  i = C(this.makeNewCrop(), o, n),
                  a = x(i, o, n),
                  s = b(i, o, n);
                this.props.onChange(a, s), this.props.onComplete(a, s);
              }
            }
          }, {
            key: "bindDocMove",
            value: function () {
              this.docMoveBound || (this.document.addEventListener("pointermove", this.onDocPointerMove, D), this.document.addEventListener("pointerup", this.onDocPointerDone, D), this.document.addEventListener("pointercancel", this.onDocPointerDone, D), this.docMoveBound = !0);
            }
          }, {
            key: "unbindDocMove",
            value: function () {
              this.docMoveBound && (this.document.removeEventListener("pointermove", this.onDocPointerMove, D), this.document.removeEventListener("pointerup", this.onDocPointerDone, D), this.document.removeEventListener("pointercancel", this.onDocPointerDone, D), this.docMoveBound = !1);
            }
          }, {
            key: "createNewCrop",
            value: function () {
              var e,
                t,
                r,
                o = this.mediaDimensions,
                n = o.width,
                i = o.height,
                a = (e = this.makeNewCrop(), t = n, r = i, !e.aspect || e.width && e.height ? e : C(e, t, r));
              return {
                pixelCrop: x(a, n, i),
                percentCrop: b(a, n, i)
              };
            }
          }, {
            key: "mediaDimensions",
            get: function () {
              var e = this.mediaWrapperRef;
              return {
                width: e.clientWidth,
                height: e.clientHeight
              };
            }
          }, {
            key: "getCropStyle",
            value: function () {
              var e = this.makeNewCrop(this.props.crop ? this.props.crop.unit : "px");
              return {
                top: "".concat(e.y).concat(e.unit),
                left: "".concat(e.x).concat(e.unit),
                width: "".concat(e.width).concat(e.unit),
                height: "".concat(e.height).concat(e.unit)
              };
            }
          }, {
            key: "getNewSize",
            value: function () {
              var e,
                t = this.props,
                r = t.crop,
                o = t.minWidth,
                n = t.maxWidth,
                i = t.minHeight,
                a = t.maxHeight,
                s = this.evData,
                c = this.mediaDimensions,
                d = c.width,
                p = c.height,
                h = s.cropStartWidth + s.xDiff;
              return s.xCrossOver && (h = Math.abs(h)), h = g(h, o, n || d), e = r.aspect ? h / r.aspect : s.cropStartHeight + s.yDiff, s.yCrossOver && (e = Math.min(Math.abs(e), s.cropStartY)), e = g(e, i, a || p), r.aspect && (h = g(e * r.aspect, 0, d)), {
                width: h,
                height: e
              };
            }
          }, {
            key: "dragCrop",
            value: function () {
              var e = this.makeNewCrop(),
                t = this.evData,
                r = this.mediaDimensions,
                o = r.width,
                n = r.height;
              return e.x = g(t.cropStartX + t.xDiff, 0, o - e.width), e.y = g(t.cropStartY + t.yDiff, 0, n - e.height), e;
            }
          }, {
            key: "resizeCrop",
            value: function () {
              var e = this.evData,
                t = this.makeNewCrop(),
                r = e.ord;
              e.xInversed && (e.xDiff -= 2 * e.cropStartWidth), e.yInversed && (e.yDiff -= 2 * e.cropStartHeight);
              var o = this.getNewSize(),
                n = e.cropStartX,
                i = e.cropStartY;
              e.xCrossOver && (n = t.x + (t.width - o.width)), e.yCrossOver && (i = !1 === e.lastYCrossover ? t.y - o.height : t.y + (t.height - o.height));
              var a = this.mediaDimensions,
                s = a.width,
                c = a.height,
                d = O(this.props.crop, {
                  unit: t.unit,
                  x: n,
                  y: i,
                  width: o.width,
                  height: o.height,
                  aspect: t.aspect
                }, s, c);
              return t.aspect || f.xyOrds.indexOf(r) > -1 ? (t.x = d.x, t.y = d.y, t.width = d.width, t.height = d.height) : f.xOrds.indexOf(r) > -1 ? (t.x = d.x, t.width = d.width) : f.yOrds.indexOf(r) > -1 && (t.y = d.y, t.height = d.height), e.lastYCrossover = e.yCrossOver, this.crossOverCheck(), t.width < this.props.minWidth || t.height < this.props.minHeight ? this.props.crop : t;
            }
          }, {
            key: "createCropSelection",
            value: function () {
              var e = this.props,
                r = e.disabled,
                o = e.locked,
                n = e.renderSelectionAddon,
                i = e.ruleOfThirds,
                a = e.crop,
                s = this.getCropStyle();
              return t().createElement("div", {
                ref: this.bindCropSelectionRef,
                style: s,
                className: "ReactCrop__crop-selection",
                onPointerDown: this.onCropPointerDown
              }, !r && !o && t().createElement("div", {
                className: "ReactCrop__drag-elements"
              }, t().createElement("div", {
                className: "ReactCrop__drag-bar ord-n",
                "data-ord": "n"
              }), t().createElement("div", {
                className: "ReactCrop__drag-bar ord-e",
                "data-ord": "e"
              }), t().createElement("div", {
                className: "ReactCrop__drag-bar ord-s",
                "data-ord": "s"
              }), t().createElement("div", {
                className: "ReactCrop__drag-bar ord-w",
                "data-ord": "w"
              }), t().createElement("div", {
                className: "ReactCrop__drag-handle ord-nw",
                "data-ord": "nw"
              }), t().createElement("div", {
                className: "ReactCrop__drag-handle ord-n",
                "data-ord": "n"
              }), t().createElement("div", {
                className: "ReactCrop__drag-handle ord-ne",
                "data-ord": "ne"
              }), t().createElement("div", {
                className: "ReactCrop__drag-handle ord-e",
                "data-ord": "e"
              }), t().createElement("div", {
                className: "ReactCrop__drag-handle ord-se",
                "data-ord": "se"
              }), t().createElement("div", {
                className: "ReactCrop__drag-handle ord-s",
                "data-ord": "s"
              }), t().createElement("div", {
                className: "ReactCrop__drag-handle ord-sw",
                "data-ord": "sw"
              }), t().createElement("div", {
                className: "ReactCrop__drag-handle ord-w",
                "data-ord": "w"
              })), n && y(a) && t().createElement("div", {
                className: "ReactCrop__selection-addon",
                onMouseDown: function (e) {
                  return e.stopPropagation();
                }
              }, n(this.state)), i && t().createElement(t().Fragment, null, t().createElement("div", {
                className: "ReactCrop__rule-of-thirds-hz"
              }), t().createElement("div", {
                className: "ReactCrop__rule-of-thirds-vt"
              })));
            }
          }, {
            key: "makeNewCrop",
            value: function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "px",
                t = m(m({}, f.defaultCrop), this.props.crop || {}),
                r = this.mediaDimensions,
                o = r.width,
                n = r.height;
              return "px" === e ? x(t, o, n) : b(t, o, n);
            }
          }, {
            key: "crossOverCheck",
            value: function () {
              var e = this.evData,
                t = this.props,
                r = t.minWidth,
                o = t.minHeight;
              !r && (!e.xCrossOver && -Math.abs(e.cropStartWidth) - e.xDiff >= 0 || e.xCrossOver && -Math.abs(e.cropStartWidth) - e.xDiff <= 0) && (e.xCrossOver = !e.xCrossOver), !o && (!e.yCrossOver && -Math.abs(e.cropStartHeight) - e.yDiff >= 0 || e.yCrossOver && -Math.abs(e.cropStartHeight) - e.yDiff <= 0) && (e.yCrossOver = !e.yCrossOver);
              var n = e.xCrossOver !== e.startXCrossOver,
                i = e.yCrossOver !== e.startYCrossOver;
              e.inversedXOrd = !!n && w(e.ord), e.inversedYOrd = !!i && w(e.ord);
            }
          }, {
            key: "render",
            value: function () {
              var e = this.props,
                r = e.children,
                o = e.circularCrop,
                n = e.className,
                i = e.crossorigin,
                s = e.crop,
                c = e.disabled,
                d = e.locked,
                p = e.imageAlt,
                h = e.onImageError,
                u = e.renderComponent,
                l = e.src,
                f = e.style,
                m = e.imageStyle,
                v = e.ruleOfThirds,
                g = this.state,
                w = g.cropIsActive,
                C = g.newCropIsBeingDrawn,
                b = y(s) && this.componentRef ? this.createCropSelection() : null,
                x = function () {
                  for (var e, t, r = 0, o = ""; r < arguments.length;) (e = arguments[r++]) && (t = a(e)) && (o && (o += " "), o += t);
                  return o;
                }("ReactCrop", n, {
                  "ReactCrop--active": w,
                  "ReactCrop--disabled": c,
                  "ReactCrop--locked": d,
                  "ReactCrop--new-crop": C,
                  "ReactCrop--fixed-aspect": s && s.aspect,
                  "ReactCrop--circular-crop": s && o,
                  "ReactCrop--rule-of-thirds": s && v,
                  "ReactCrop--invisible-crop": !this.dragStarted && s && !s.width && !s.height
                });
              return t().createElement("div", {
                ref: this.bindComponentRef,
                className: x,
                style: f,
                onPointerDown: this.onComponentPointerDown,
                tabIndex: 0,
                onKeyDown: this.onComponentKeyDown,
                onKeyUp: this.onComponentKeyUp
              }, t().createElement("div", {
                ref: this.bindMediaWrapperRef
              }, u || t().createElement("img", {
                ref: this.bindImageRef,
                crossOrigin: i,
                className: "ReactCrop__image",
                style: m,
                src: l,
                onLoad: this.onImageLoad,
                onError: h,
                alt: p
              })), r, b);
            }
          }]) && d(r.prototype, o), f;
        }(e.PureComponent);
      S.xOrds = ["e", "w"], S.yOrds = ["n", "s"], S.xyOrds = ["nw", "ne", "se", "sw"], S.nudgeStep = 1, S.nudgeStepMedium = 10, S.nudgeStepLarge = 100, S.defaultCrop = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        unit: "px"
      }, S.propTypes = {
        className: i().string,
        children: i().oneOfType([i().arrayOf(i().node), i().node]),
        circularCrop: i().bool,
        crop: i().shape({
          aspect: i().number,
          x: i().number,
          y: i().number,
          width: i().number,
          height: i().number,
          unit: i().oneOf(["px", "%"])
        }),
        crossorigin: i().string,
        disabled: i().bool,
        locked: i().bool,
        imageAlt: i().string,
        imageStyle: i().shape({}),
        keepSelection: i().bool,
        minWidth: i().number,
        minHeight: i().number,
        maxWidth: i().number,
        maxHeight: i().number,
        onChange: i().func.isRequired,
        onImageError: i().func,
        onComplete: i().func,
        onImageLoaded: i().func,
        onDragStart: i().func,
        onDragEnd: i().func,
        src: i().string.isRequired,
        style: i().shape({}),
        renderComponent: i().node,
        renderSelectionAddon: i().func,
        ruleOfThirds: i().bool
      }, S.defaultProps = {
        circularCrop: !1,
        className: void 0,
        crop: void 0,
        crossorigin: void 0,
        disabled: !1,
        locked: !1,
        imageAlt: "",
        maxWidth: void 0,
        maxHeight: void 0,
        minWidth: 0,
        minHeight: 0,
        keepSelection: !1,
        onComplete: function () {},
        onImageError: function () {},
        onImageLoaded: function () {},
        onDragStart: function () {},
        onDragEnd: function () {},
        children: void 0,
        style: void 0,
        renderComponent: void 0,
        imageStyle: void 0,
        renderSelectionAddon: void 0,
        ruleOfThirds: !1
      };
    })(), n;
  })();
});